module.exports = __webpack_public_path__ + "assets/webgl/ConcreteFloor_Albedo.52ca6a70.jpg";